import React, { useState } from 'react'
import Button from '@mui/material/Button'
import MenuIcon from '@mui/icons-material/Menu'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Link from '@mui/material/Link'
import { Link as RouterLink } from 'react-router-dom'
import { useBrand } from 'components/shared/SettingsProvider'

const MobileNav = ({ sections }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { marcomUrl } = useBrand()

  function handleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  return (
    <>
      <Button
        aria-controls='mobile-menu'
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MenuIcon htmlColor='white' />
      </Button>
      <Menu
        id='mobile-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <Link href={`${marcomUrl}/bright-horizons/virtual-camp`}>
            Learn More
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link href='/'>Log In</Link>
        </MenuItem>
      </Menu>
    </>
  )
}

export default MobileNav
